// SF5 — ad spend on products that cannot convert right now.
//
// Sponsored ads only serve on the featured offer. A low Buy Box win rate is not
// "fewer sales" — it is the ad not appearing at all while the budget sits
// there, which is why it sits under readiness and not under bidding.
//
// Every skipped check is named. A product whose Buy Box could not be read is
// reported as unchecked, never as fine.
import React from 'react';
import s from '../AdsHealth.module.css';
import { money, pct, ratio, STATE_TONE } from '../format';

export default function Readiness({ data, currency }) {
  if (!data) return <p className={s.empty}>Loading…</p>;
  if (!(data.products || []).length) {
    return <p className={s.empty}>No advertised products in this window.</p>;
  }
  const c = data.counts || {};

  return (
    <div>
      <div className={s.stats}>
        <div className={s.stat}>
          <span className={s.statValue}>{money(data.spend_at_risk, currency)}</span>
          <span className={s.statLabel}>spent on products that cannot convert now</span>
        </div>
        <div className={s.stat}>
          <span className={s.statValue}>{c['Not ready'] || 0}</span>
          <span className={s.statLabel}>not ready</span>
        </div>
        <div className={s.stat}>
          <span className={s.statValue}>{c['At risk'] || 0}</span>
          <span className={s.statLabel}>at risk</span>
        </div>
        <div className={s.stat}>
          <span className={s.statValue}>{c.Ready || 0}</span>
          <span className={s.statLabel}>ready</span>
        </div>
      </div>

      {data.skipped_note && <p className={s.coverageWarn}>{data.skipped_note}</p>}
      {data.idq_note && <p className={s.coverage}>{data.idq_note}</p>}
      {data.event_note && <p className={s.coverage}>{data.event_note}</p>}

      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>Product</th><th>Readiness</th><th className={s.right}>Ad spend</th>
              <th className={s.right}>ACOS</th><th className={s.right}>Buy Box</th>
              <th className={s.right}>Stock</th><th>Stage</th><th>Why</th>
            </tr>
          </thead>
          <tbody>
            {data.products.map((p) => (
              <tr key={p.asin}>
                <td>
                  <span className={s.asin}>{p.asin}</span>
                  {p.sku && <div className={s.thin}>{p.sku}</div>}
                </td>
                <td>
                  <span className={s[STATE_TONE[p.state] || 'muted']}>{p.state}</span>
                </td>
                <td className={s.right}>{money(p.spend, currency)}</td>
                <td className={s.right}>{ratio(p.acos, p.acos_reason)}</td>
                <td className={s.right}>
                  {p.buy_box_rate == null
                    ? <span className={s.thin}>not checked</span>
                    : pct(p.buy_box_rate)}
                </td>
                <td className={s.right}>
                  {p.days_on_hand == null
                    ? <span className={s.thin}>not checked</span>
                    : `${p.days_on_hand} days`}
                </td>
                <td className={s.thin} title={p.lifecycle_why}>{p.lifecycle}</td>
                <td className={s.thin} style={{ maxWidth: 420 }}>
                  {(p.why || []).join(' ') || '—'}
                  {p.idq_withheld && (
                    <div style={{ color: '#98A1B0', marginTop: 4 }}>
                      Listing quality measured, withheld until calibration.
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
